
//export const baseurl = "http://localhost:5000"
export const baseurl = "https://apicap.cep.ac.in"